export const typeLabel = (type) =>
  ({ audio: "meditation", bundle: "collection", ebook: "ebook", physical: "physical", signature: "signature" }[type] || type);
